import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import styles from './styles/MyClassrooms.module.css';
import MyClassroomsSidebar from './MyClassroomsSidebar';
import MyClassroomsHeader from './MyClassroomsHeader';
import MyClassroomsGrid from './MyClassroomsGrid';
import Classroom from './Classroom';
import ClassroomSidebar from './ClassroomSidebar';
import Loading from '../loading/Loading';
import ClassroomCalendar from './calendar/ClassroomCalendar';
import { ClassroomContext } from '../../context/ClassroomContext';
import { useActiveClassroomId } from './classroomPaths';

const MyClassrooms = () => {
    const { loading } = useContext(ClassroomContext);

    // Not every page under /my-classrooms/ is a classroom — the calendar is global.
    const isClassroomPage = Boolean(useActiveClassroomId());


    return (
        <div className={styles.myClassroomsContainer}>
            <MyClassroomsHeader />
            <div className={styles.myClassroomsBody}>
            {loading ? (
                <div className={styles.loading}>
                    <Loading />
                </div>
            ) : (
                <>
                    {isClassroomPage ? <ClassroomSidebar /> : <MyClassroomsSidebar />}
                    <Routes>
                        <Route path="/" element={<MyClassroomsGrid />} />
                        {/* Static, so it outranks /:classroomId/* below. */}
                        <Route path="/calendar" element={<ClassroomCalendar />} />
                        <Route path="/:classroomId/*" element={<Classroom />} />
                    </Routes>
                </>
            )}

            </div>
        </div>
    );
};

export default MyClassrooms;
